<!-- eslint-disable max-len -->
<template>
<svg
    xmlns="http://www.w3.org/2000/svg" width="48" height="48"
    viewBox="0 0 48 48" fill="none"
>
    <path
        d="M4.12501 24.6967C3.95833 24.2477 3.95833 23.7538 4.12501 23.3047C5.74841 19.3684 8.50404 16.0028 12.0426 13.6345C15.5811 11.2662 19.7431 10.002 24.001 10.002C28.2589 10.002 32.421 11.2662 35.9595 13.6345C39.498 16.0028 42.2536 19.3684 43.877 23.3047C44.0437 23.7538 44.0437 24.2477 43.877 24.6967C42.2536 28.633 39.498 31.9986 35.9595 34.3669C32.421 36.7352 28.2589 37.9995 24.001 37.9995C19.7431 37.9995 15.5811 36.7352 12.0426 34.3669C8.50404 31.9986 5.74841 28.633 4.12501 24.6967Z" stroke="currentColor" stroke-width="4"
        stroke-linecap="round" stroke-linejoin="round"
    />
    <path
        d="M24 30C27.3137 30 30 27.3137 30 24C30 20.6863 27.3137 18 24 18C20.6863 18 18 20.6863 18 24C18 27.3137 20.6863 30 24 30Z" stroke="currentColor" stroke-width="4"
        stroke-linecap="round" stroke-linejoin="round"
    />
</svg>
</template>
